const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://chesiwms-production-1eb5.up.railway.app/api';

// Function to detect country from IP or browser
const detectCountry = async () => {
  try {
    // Try to get country from browser's Intl API
    const locale = Intl.DateTimeFormat().resolvedOptions().locale;
    const region = locale.split('-')[1];
    
    // Try to get country from timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    // Try to get country from IP geolocation service (free tier)
    try {
      const geoResponse = await fetch('https://ipapi.co/json/', { timeout: 2000 });
      if (geoResponse.ok) {
        const geoData = await geoResponse.json();
        if (geoData.country_name) {
          return geoData.country_name;
        }
      }
    } catch (e) {
      // Fallback if geolocation fails
    }
    
    // Fallback: try to infer from timezone
    const timezoneToCountry = {
      'Africa/Nairobi': 'Kenya',
      'Africa/Lagos': 'Nigeria',
      'Africa/Johannesburg': 'South Africa',
      'Africa/Accra': 'Ghana',
      'Africa/Kampala': 'Uganda',
      'Africa/Dar_es_Salaam': 'Tanzania',
      'Africa/Cairo': 'Egypt',
      'Africa/Addis_Ababa': 'Ethiopia'
    };
    
    return timezoneToCountry[timezone] || null;
  } catch (error) {
    console.error('Error detecting country:', error);
    return null;
  }
};

class ApiService {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Request failed');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // Get public pricing plans
  async getPricingPlans() {
    return this.request('/license-tiers/public');
  }

  // Submit plan selection
  async submitPlanSelection(data) {
    // Detect and add country if not provided
    if (!data.country) {
      const country = await detectCountry();
      if (country) {
        data.country = country;
      }
    }
    
    return this.request('/plan-selection/submit', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // Get page by slug
  async getPageBySlug(slug) {
    return this.request(`/cms/pages/${slug}`);
  }

  // Support Ticket endpoints
  async createSupportTicket(ticketData, files = []) {
    const formData = new FormData();
    
    // Append form fields
    Object.keys(ticketData).forEach(key => {
      if (ticketData[key] !== undefined && ticketData[key] !== null) {
        formData.append(key, ticketData[key]);
      }
    });

    // Append files
    files.forEach(file => {
      formData.append('attachments', file);
    });

    const url = `${API_BASE_URL}/support-tickets`;
    const response = await fetch(url, {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Request failed');
    }

    return data;
  }

  async getSupportTicketsByLicense(licenseKey, filters = {}) {
    const queryParams = new URLSearchParams(filters).toString();
    return this.request(`/support-tickets/license/${licenseKey}${queryParams ? `?${queryParams}` : ''}`);
  }
}

export default new ApiService();

